import React, { useState } from 'react';
import Header from './components/common/Header';
import Home from './components/pages/Home';
import Gallery from './components/pages/Gallery';
import Games from './components/pages/Games';
import Contact from './components/pages/Contact';
import './index.css';
import News from './components/pages/News';
import About from './components/pages/About';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
  return <Home setCurrentPage={setCurrentPage} />;
      case 'gallery':
        return <Gallery />;
      case 'games':
        return <Games />;
      case 'news':
        return <News />;
      case 'about':
        return <About />;
      case 'contact':
        return <Contact />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="App">
      <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <main>
        {renderPage()}
      </main>
    </div>
  );
}

export default App;